import React from "react";

const Headline = () => {
  return (
    <div>
      <h1 className="app__title">Our Menu</h1>
      <div className="app__underline"></div>
    </div>
  );
};

export default Headline;
